export default __webpack_public_path__ + "static/media/2.blur.0f41cc60.jpeg";